import type { components } from '#/api/schema'
import { mapETicketMediaList } from '#/utils/eTicketMedia'
import { createEnumGuard } from '#/utils/typeGuards'
import type { TTicketType } from '#pages/ETickets/interfaces'

import { type IMyETicket, TRAVELLER_STATUSES, type TTravellerStatus, type TTravellerStatusFilter } from './interfaces'

export const isTravellerStatus = createEnumGuard(TRAVELLER_STATUSES)

export const isTravellerStatusFilter = (value: string): value is TTravellerStatusFilter =>
  value === 'all' || isTravellerStatus(value)

export const getTravellerStatusLabel = (status: TTravellerStatus, t: (key: string) => string): string => {
  switch (status) {
    case 'upcoming':
      return t('Upcoming')
    case 'today':
      return t('Today')
    case 'expired':
      return t('Expired')
    case 'processing':
      return t('Processing')
    case 'failed':
      return t('Failed')
    default:
      return status
  }
}

export const getTicketTypeLabel = (ticketType: TTicketType, t: (key: string) => string): string => {
  switch (ticketType) {
    case 'one_way':
      return t('One way')
    case 'round_trip':
      return t('Round trip')
    case 'one_way_off_peak':
      return t('One way (off-peak)')
    case 'round_trip_off_peak':
      return t('Round trip (off-peak)')
    default:
      return ticketType
  }
}

export const getTrainClassLabel = (trainClass: 1 | 2, t: (key: string) => string): string =>
  trainClass === 1 ? t('1st class') : t('2nd class')

export const formatTicketRoute = (fromStationName: string, toStationName: string): string =>
  `${fromStationName} → ${toStationName}`

export const mapMyETicket = (item: components['schemas']['ETicketItem']): IMyETicket => ({
  id: item.id,
  fromStationName: item.fromStationName ?? item.fromStation,
  toStationName: item.toStationName ?? item.toStation,
  trainClass: item.trainClass,
  ticketType: item.ticketType,
  travelDate: item.travelDate,
  travelTime: item.travelTime ?? null,
  price: item.price ?? null,
  travellerStatus: isTravellerStatus(item.travellerStatus) ? item.travellerStatus : 'processing',
  media: mapETicketMediaList(item.media),
  tag: item.tag ?? null,
  deliveryMethod: item.deliveryMethod ?? 'homeprint',
})
